"use client";

/**
 * filter-fold.tsx — 筛选行折叠(客户端叶子)
 *
 * SSR 仍全量渲染所有筛选 chip(服务端分面与无 JS 回退不受影响),
 * 视觉上只露前 max 枚,长尾一键展开。课库话题长尾 150+,不折叠会把
 * 课卡和「练这个话题」桥压到两屏之外。
 */

import { Children, useState } from "react";

export function FilterFold({
  children,
  max = 14,
  moreLabel,
}: {
  children: React.ReactNode;
  max?: number;
  /** 展开按钮文案,{n} 替换为被收起数量(函数 prop 无法跨 RSC 边界,故用模板串) */
  moreLabel?: string;
}) {
  const [open, setOpen] = useState(false);
  const items = Children.toArray(children);
  if (items.length <= max) return <>{children}</>;
  return (
    <>
      {open ? items : items.slice(0, max)}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="rounded-full border border-dashed border-[#35503E] px-3 py-1 text-xs text-stone-500 transition hover:border-amber-300/50 hover:text-amber-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300/70"
      >
        {open
          ? "收起 ↑"
          : (moreLabel ?? "还有 {n} 个 ↓").replace("{n}", String(items.length - max))}
      </button>
    </>
  );
}
